import classNames from 'classnames';
import { MouseEvent } from 'react';
import ArrowSq from '../../icons/ArrowSq';
import IconButton from '../IconButton';
import styles from './styles/styles.module.scss';

type ArrowButtonProps = { className?: string; onClick: () => void; title: string };

const ArrowButton = (orientation: 'left' | 'right') =>
  function ({ className, onClick, title }: ArrowButtonProps) {
    return (
      <IconButton
        className={classNames(styles[`${orientation}Arrow`], className)}
        icon={{ Component: ArrowSq, orientation }}
        onClick={(e?: MouseEvent) => {
          e?.preventDefault();
          e?.stopPropagation();
          onClick();
        }}
        title={title}
        size="md"
        variant="elevated"
      />
    );
  };

export const LeftArrow = ArrowButton('left');
export const RightArrow = ArrowButton('right');
